export const breakpoints = ['800px', '1200px']
